// extracted by mini-css-extract-plugin
export var fullWidthButton = "_pq-0";